import { useState, useEffect, useMemo } from 'react'

import API from '../../../../api/api'
import { getBuildingOptionsPmOrFd, getBuildingOptions } from '../helpers'

export const useBuildingOptions = (userData) => {
  const [buildings, setBuildings] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const isPropertyManager = userData.user.role === 'PropertyManager'
  const isFrontDesk = userData.user.role === 'ShiftManager'
  const isPropertyManagerOrFrontDesk = ['PropertyManager', 'ShiftManager'].includes(
    userData.user.role,
  )
  const isManagerOrAdmin = ['Manager', 'Administrator'].includes(userData.user.role)

  const buildingOptions = useMemo(() => {
    if (isPropertyManagerOrFrontDesk) {
      return getBuildingOptionsPmOrFd(isPropertyManager, isFrontDesk, userData)
    }

    if (buildings.length) {
      return getBuildingOptions(buildings)
    }

    return []
  }, [isPropertyManagerOrFrontDesk, isPropertyManager, isFrontDesk, userData, buildings])

  const fetchBuildings = async () => {
    try {
      setIsLoading(true)
      const data = await API.getAllBuildings()

      setBuildings(data || [])
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isManagerOrAdmin) {
      fetchBuildings()
    }
  }, [])

  return { buildingOptions, isLoading }
}
